/* eslint-disable react/no-unescaped-entities */
import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function AboutUsComponent() {
  return (
    <Container
      id="aboutus"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 }
      }}>
      <Typography
        component="h1"
        variant="h4"
        color="text.primary"
        sx={{
          width: { sm: '100%', md: '80%' },
          textAlign: 'center',
          mb: 4
        }}>
        👩🏽‍⚕️ About Us
      </Typography>

      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 5 },
          width: '100%',
          bgcolor: 'background.paper',
          borderRadius: 2
        }}>
        <Box sx={{ width: '100%' }}>
          <Typography variant="body1" paragraph>
            We're a group of UK-trained GPs who have recently completed our CCT and understand
            firsthand how demanding the Simulated Consultation Assessment (SCA) can be. Having all
            scored highly in the SCA, we recognised a gap in the revision resources available to
            trainees.
          </Typography>

          <Typography variant="body1" paragraph>
            Many tools on the market simply recycle old CSA cases and repackage them for the SCA —
            but the style, structure, and marking of the SCA is very different. We believe you
            shouldn't waste valuable revision time trying to adapt outdated content to a new format.
          </Typography>

          <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 4 }}>
            That's why we built this platform:
          </Typography>

          <Typography variant="body1" paragraph>
            To offer original, realistic SCA-style cases created by doctors who've actually sat and
            passed the exam — and to do so in a way that's affordable, accessible, and designed for
            how trainees revise today.
          </Typography>

          <Typography variant="body1" paragraph>
            Whether you're preparing alone or with colleagues, our goal is to give you the most
            exam- relevant practice possible — so you can walk into your SCA feeling confident and
            ready.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
